import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-white shadow w-full lg:container md:container rounded-2xl py-4 justify-between items-start h-full min-h-screen" }
const _hoisted_2 = { class: "space-y-3 p-3 w-full" }
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Services", -1)
const _hoisted_5 = { class: "lg:grid lg:grid-cols-2 md:grid-cols-2 flex flex-row" }
const _hoisted_6 = { class: "space-x-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Managed job status", -1)
const _hoisted_8 = {
  key: 0,
  class: "text-sm font-extralight text-orange-400"
}
const _hoisted_9 = {
  key: 1,
  class: "text-sm font-extralight text-green-500"
}
const _hoisted_10 = {
  key: 2,
  class: "text-sm font-extralight text-red-400"
}
const _hoisted_11 = { class: "lg:grid lg:grid-cols-2 md:grid-cols-2 flex flex-col space-y-4" }
const _hoisted_12 = { class: "space-x-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "AI Talent Matching", -1)
const _hoisted_14 = { class: "space-x-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Job type", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_17 = { class: "space-y-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Department Details", -1)
const _hoisted_19 = { class: "flex flex-col lg:flex-row items-center" }
const _hoisted_20 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Department", -1)
const _hoisted_22 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Internal Code", -1)
const _hoisted_24 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Company", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_27 = { class: "space-y-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Location", -1)
const _hoisted_29 = { class: "flex flex-col lg:flex-row items-center justify-between" }
const _hoisted_30 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Country", -1)
const _hoisted_32 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Region or City ", -1)
const _hoisted_34 = { class: "flex flex-row items-center w-full lg:justify-end mt-3 lg:mt-0" }
const _hoisted_35 = {
  key: 0,
  class: "px-7 p-5 sm:p-2 text-primary-dark bg-primary-light text-xs rounded capitalize-letter"
}
const _hoisted_36 = {
  key: 1,
  class: "text-primary text-sm"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_38 = { class: "space-y-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Job Information", -1)
const _hoisted_40 = { class: "space-y-3 block" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400 block" }, "Description", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_43 = { class: "space-y-3 block" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400 block" }, "Requirements", -1)
const _hoisted_45 = {
  key: 0,
  class: "list-disc p-3"
}
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = {
  key: 1,
  class: "text-primary-dark text-sm font-extralight block"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_49 = { class: "space-y-3 block" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400 block" }, "Responsibilities", -1)
const _hoisted_51 = {
  key: 0,
  class: "list-disc p-3"
}
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = {
  key: 1,
  class: "text-primary-dark text-sm font-extralight block"
}
const _hoisted_54 = { class: "job_comment_section" }
const _hoisted_55 = {
  key: 0,
  class: "py-2"
}
const _hoisted_56 = { class: "grid justify-items-end py-2" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
  })
], -1)
const _hoisted_58 = { class: "space-y-3 block" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400 block" }, " Benefits ", -1)
const _hoisted_60 = {
  key: 0,
  class: "list-disc p-3"
}
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = {
  key: 1,
  class: "text-primary-dark text-sm font-extralight block"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_64 = { class: "space-y-4" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Company Industry and Job Function", -1)
const _hoisted_66 = { class: "flex flex-col lg:flex-row items-center" }
const _hoisted_67 = { class: "flex flex-row w-full space-x-8 items-center py-3" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Industry", -1)
const _hoisted_69 = { class: "flex flex-row w-full space-x-8 items-center py-3" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Job Function", -1)
const _hoisted_71 = { class: "job_comment_section" }
const _hoisted_72 = { class: "py-2" }
const _hoisted_73 = { class: "grid justify-items-end py-2" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
  })
], -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_76 = { class: "space-y-4" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Employment Details ", -1)
const _hoisted_78 = { class: "flex flex-col lg:flex-row items-center" }
const _hoisted_79 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Employment Type", -1)
const _hoisted_81 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Experience", -1)
const _hoisted_83 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Education", -1)
const _hoisted_85 = { class: "job_comment_section" }
const _hoisted_86 = { class: "py-2" }
const _hoisted_87 = { class: "grid justify-items-end py-2" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
  })
], -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_90 = { class: "flex flex-col" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("span", { class: "block text-lg font-bold" }, "Skills", -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 mb-2 font-normal" }, "Required", -1)
const _hoisted_93 = {
  key: 0,
  class: "w-full flex flex-wrap content-center"
}
const _hoisted_94 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_95 = {
  key: 2,
  class: "mt-5 text-gray-400 mb-2 font-normal"
}
const _hoisted_96 = { class: "w-full flex flex-wrap content-center" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_98 = { class: "space-y-2" }
const _hoisted_99 = { class: "block text-lg font-bold" }
const _hoisted_100 = { class: "text-gray-500 font-semibold" }
const _hoisted_101 = { class: "flex flex-row items-center" }
const _hoisted_102 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "From", -1)
const _hoisted_104 = { class: "text-sm font-extralight" }
const _hoisted_105 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "To", -1)
const _hoisted_107 = { class: "text-sm font-extralight" }
const _hoisted_108 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Currency", -1)
const _hoisted_110 = { class: "text-sm font-extralight" }
const _hoisted_111 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_112 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "From", -1)
const _hoisted_114 = { class: "text-sm font-extralight" }
const _hoisted_115 = { class: "flex flex-row w-full space-x-4 items-center py-3" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "To", -1)
const _hoisted_117 = { class: "text-sm font-extralight" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row w-full space-x-4 items-center py-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight text-gray-400" }, "Currency"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-extralight" }, " USD ")
], -1)
const _hoisted_119 = { class: "job_comment_section" }
const _hoisted_120 = { class: "py-2" }
const _hoisted_121 = { class: "grid justify-items-end py-2" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_TimeLine = _resolveComponent("TimeLine")!
  const _component_Button = _resolveComponent("Button")!
  const _component_JobCommentForm = _resolveComponent("JobCommentForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (_ctx.data.job_status === 'pending_approval')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " pending approval "))
              : _createCommentVNode("", true),
            (_ctx.data.job_status === 'published' && _ctx.data.is_managed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Active "))
              : _createCommentVNode("", true),
            (!_ctx.data.is_managed && _ctx.data.job_status !== 'pending_approval')
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Inactive "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-extralight", {
                'text-green-500': _ctx.data.match_candidates,
                'text-red-400': !_ctx.data.match_candidates,
              }])
            }, _toDisplayString(_ctx.data.match_candidates ? "On" : "Off"), 3)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-extralight", { 'text-primary-purple': _ctx.data.is_confidential }])
            }, _toDisplayString(_ctx.data.is_confidential ? "Confidential" : "Public"), 3)
          ])
        ])
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-extralight capitalize", _ctx.data && !_ctx.data.department && 'text-primary-dark'])
            }, _toDisplayString(_ctx.data && _ctx.data.department ? _ctx.data.department : _ctx.labelNoInfo), 3)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-extralight", _ctx.data && !_ctx.data.department_code && 'text-primary-dark'])
            }, _toDisplayString(_ctx.data && _ctx.data.department_code
                  ? _ctx.data.department_code
                  : _ctx.labelNoInfo), 3)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-extralight", _ctx.data && !_ctx.data.company && 'text-primary-dark'])
            }, _toDisplayString(_ctx.data && _ctx.data.company ? _ctx.data.company.visible_name : _ctx.labelNoInfo), 3)
          ])
        ])
      ]),
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-extralight", 
                _ctx.data &&
                !_ctx.data.job_location?.location?.country &&
                'text-primary-dark'
              ])
            }, _toDisplayString(_ctx.data && _ctx.data.job_location?.location?.country
                  ? _ctx.data.job_location?.location?.country
                  : _ctx.labelNoInfo), 3)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-extralight", 
                _ctx.data && !_ctx.data.job_location?.location.city && 'text-primary-dark'
              ])
            }, _toDisplayString(_ctx.data && _ctx.data.job_location?.location?.city
                  ? _ctx.data.job_location?.location.city +
                    ", " +
                    _ctx.data.job_location?.location.state
                  : _ctx.labelNoInfo), 3)
          ]),
          _createElementVNode("div", _hoisted_34, [
            (_ctx.data.work_type)
              ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.data.work_type.replaceAll("_", " ")), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_36, " Preferred work type no added "))
          ])
        ])
      ]),
      _hoisted_37,
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("span", {
            class: _normalizeClass(["text-sm font-extralight block", _ctx.data && _ctx.data.description === '' && 'text-primary-dark'])
          }, _toDisplayString(_ctx.data && _ctx.data.description !== ""
                ? _ctx.data.description
                : "No information"), 3)
        ]),
        _hoisted_42,
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          (_ctx.data && _ctx.data.requirements !== '<li></li>')
            ? (_openBlock(), _createElementBlock("ul", _hoisted_45, [
                _createElementVNode("span", {
                  class: "text-sm font-extralight block",
                  innerHTML: _ctx.data.requirements
                }, null, 8, _hoisted_46)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_47, "No information"))
        ]),
        _hoisted_48,
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          (_ctx.data && _ctx.data.responsabilities !== '<li></li>')
            ? (_openBlock(), _createElementBlock("ul", _hoisted_51, [
                _createElementVNode("span", {
                  class: "text-sm font-extralight block",
                  innerHTML: _ctx.data.responsabilities
                }, null, 8, _hoisted_52)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_53, "No information"))
        ]),
        _createElementVNode("div", _hoisted_54, [
          (_ctx.infoCommentStore && _ctx.infoCommentStore.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                (_ctx.loadingTimeline)
                  ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_TimeLine, {
                      key: 1,
                      timeline: _ctx.infoCommentStore
                    }, null, 8, ["timeline"]))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_56, [
            _createVNode(_component_Button, {
              label: _ctx.expand.comment_info ? 'Close' : 'Add a comment',
              variant: "",
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expand.comment_info = !_ctx.expand.comment_info))
            }, {
              startIcon: _withCtx(() => [
                _hoisted_57
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_JobCommentForm, {
              section: "job_info",
              onGetDescriptionComments: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getCommentsBySection('getInfoComments')))
            })
          ], 512), [
            [_vShow, _ctx.expand.comment_info]
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _hoisted_59,
          (_ctx.data && _ctx.data.job_benefits !== '<li></li>')
            ? (_openBlock(), _createElementBlock("ul", _hoisted_60, [
                _createElementVNode("span", {
                  class: "text-sm font-extralight block",
                  innerHTML: _ctx.data.job_benefits
                }, null, 8, _hoisted_61)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_62, "No information"))
        ])
      ]),
      _hoisted_63,
      _createElementVNode("div", _hoisted_64, [
        _hoisted_65,
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _hoisted_68,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-extralight", 
                _ctx.data && !_ctx.data?.company_industry?.name && 'text-primary-dark'
              ])
            }, _toDisplayString(_ctx.data && _ctx.data.company_industry && _ctx.data.company_industry.name
                  ? _ctx.data.company_industry.name
                  : _ctx.labelNoInfo), 3)
          ]),
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-extralight", _ctx.data && !_ctx.data?.job_function?.name && 'text-primary-dark'])
            }, _toDisplayString(_ctx.data && _ctx.data.job_function && _ctx.data.job_function.name
                  ? _ctx.data.job_function.name
                  : _ctx.labelNoInfo), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            (_ctx.loadingTimeline)
              ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
              : (_openBlock(), _createBlock(_component_TimeLine, {
                  key: 1,
                  timeline: _ctx.functionCommentStore
                }, null, 8, ["timeline"]))
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createVNode(_component_Button, {
              label: _ctx.expand.comment_function ? 'Close' : 'Add a comment',
              variant: "",
              onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expand.comment_function = !_ctx.expand.comment_function))
            }, {
              startIcon: _withCtx(() => [
                _hoisted_74
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_JobCommentForm, {
              section: 'job_function',
              onGetDescriptionComments: _cache[3] || (_cache[3] = ($event: any) => (
                _ctx.getCommentsBySection('getFunctionComments')
              ))
            })
          ], 512), [
            [_vShow, _ctx.expand.comment_function]
          ])
        ])
      ]),
      _hoisted_75,
      _createElementVNode("div", _hoisted_76, [
        _hoisted_77,
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-extralight capitalize", _ctx.data && !_ctx.data?.employment_type && 'text-primary-dark'])
            }, _toDisplayString(_ctx.data && _ctx.data?.employment_type
                  ? _ctx.replaceEnum(_ctx.data?.employment_type)
                  : _ctx.labelNoInfo), 3)
          ]),
          _createElementVNode("div", _hoisted_81, [
            _hoisted_82,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-extralight capitalize", _ctx.data && !_ctx.data?.experience && 'text-primary-dark'])
            }, _toDisplayString(_ctx.data && _ctx.data?.experience
                  ? _ctx.replaceEnum(_ctx.data?.experience)
                  : _ctx.labelNoInfo), 3)
          ]),
          _createElementVNode("div", _hoisted_83, [
            _hoisted_84,
            _createElementVNode("span", {
              class: _normalizeClass(["text-sm font-extralight capitalize", _ctx.data && !_ctx.data?.education && 'text-primary-dark'])
            }, _toDisplayString(_ctx.data && _ctx.data?.education
                  ? _ctx.replaceEnum(_ctx.data?.education)
                  : _ctx.labelNoInfo), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("div", _hoisted_86, [
            (_ctx.loadingTimeline)
              ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
              : (_openBlock(), _createBlock(_component_TimeLine, {
                  key: 1,
                  timeline: _ctx.detailsCommentStore
                }, null, 8, ["timeline"]))
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createVNode(_component_Button, {
              label: _ctx.expand.comment_details ? 'Close' : 'Add a comment',
              variant: "",
              onOnClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expand.comment_details = !_ctx.expand.comment_details))
            }, {
              startIcon: _withCtx(() => [
                _hoisted_88
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_JobCommentForm, {
              section: 'job_details',
              onGetDescriptionComments: _cache[5] || (_cache[5] = ($event: any) => (
                _ctx.getCommentsBySection('getDetailsComments')
              ))
            })
          ], 512), [
            [_vShow, _ctx.expand.comment_details]
          ])
        ])
      ]),
      _hoisted_89,
      _createElementVNode("div", _hoisted_90, [
        _hoisted_91,
        _hoisted_92,
        (_ctx.data && _ctx.data.required_skills && _ctx.data.required_skills.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.required_skills, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "chip flex items-center mx-1 rounded-lg px-2 py-1 text-md bg-primary-light text-primary-dark",
                  key: index
                }, _toDisplayString(item.name), 1))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_94, "Not required skills in this job.")),
        (_ctx.data && _ctx.data.optional_skills && _ctx.data.optional_skills.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_95, "Nice to have"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_96, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.optional_skills, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "chip flex items-center mx-1 rounded-lg px-2 py-1 text-md bg-primary-light text-primary-dark",
              key: index
            }, _toDisplayString(item.name), 1))
          }), 128))
        ])
      ]),
      _hoisted_97,
      _createElementVNode("div", _hoisted_98, [
        _createElementVNode("span", _hoisted_99, [
          _createTextVNode(_toDisplayString(_ctx.data && _ctx.data.show_monthly_salary
              ? "Monthly Salary"
              : "Annual Salary") + " ", 1),
          _createElementVNode("span", _hoisted_100, "(" + _toDisplayString(_ctx.data.salary_type === "bruto" ? "Gross Salary" : "Net Salary") + ")", 1)
        ]),
        _createElementVNode("div", _hoisted_101, [
          _createElementVNode("div", _hoisted_102, [
            _hoisted_103,
            _createElementVNode("span", _hoisted_104, _toDisplayString(`$${
                  _ctx.data && _ctx.data.salary_min
                    ? _ctx.numberWithCommas(
                        parseInt(
                          _ctx.data.show_monthly_salary
                            ? _ctx.data.salary_min.to_show
                            : _ctx.data.salary_min.annual,
                          10
                        )
                      )
                    : "0"
                }`), 1)
          ]),
          _createElementVNode("div", _hoisted_105, [
            _hoisted_106,
            _createElementVNode("span", _hoisted_107, _toDisplayString(`$${
                  _ctx.data && _ctx.data.salary_max
                    ? _ctx.numberWithCommas(
                        parseInt(
                          _ctx.data.show_monthly_salary
                            ? _ctx.data.salary_max.to_show
                            : _ctx.data.salary_max.annual,
                          10
                        )
                      )
                    : "0"
                }`), 1)
          ]),
          _createElementVNode("div", _hoisted_108, [
            _hoisted_109,
            _createElementVNode("span", _hoisted_110, _toDisplayString(`${_ctx.data && _ctx.data.currency_salary ? _ctx.data.currency_salary : "-"}`), 1)
          ])
        ]),
        (_ctx.data && _ctx.data.currency_salary && _ctx.data.currency_salary !== 'USD')
          ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
              _createElementVNode("div", _hoisted_112, [
                _hoisted_113,
                _createElementVNode("span", _hoisted_114, _toDisplayString(`$${
                  _ctx.data && _ctx.data.salary_min
                    ? _ctx.numberWithCommas(
                        parseInt(_ctx.data.salary_min.to_show_usd, 10)
                      )
                    : "0"
                }`), 1)
              ]),
              _createElementVNode("div", _hoisted_115, [
                _hoisted_116,
                _createElementVNode("span", _hoisted_117, _toDisplayString(`$${
                  _ctx.data && _ctx.data.salary_max
                    ? _ctx.numberWithCommas(
                        parseInt(_ctx.data.salary_max.to_show_usd, 10)
                      )
                    : "0"
                }`), 1)
              ]),
              _hoisted_118
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_119, [
          _createElementVNode("div", _hoisted_120, [
            (_ctx.loadingTimeline)
              ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
              : (_openBlock(), _createBlock(_component_TimeLine, {
                  key: 1,
                  timeline: _ctx.salaryCommentStore
                }, null, 8, ["timeline"]))
          ]),
          _createElementVNode("div", _hoisted_121, [
            _createVNode(_component_Button, {
              label: _ctx.expand.comment_salary ? 'Close' : 'Add a comment',
              variant: "",
              onOnClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.expand.comment_salary = !_ctx.expand.comment_salary))
            }, {
              startIcon: _withCtx(() => [
                _hoisted_122
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_JobCommentForm, {
              section: 'job_salary',
              onGetDescriptionComments: _cache[7] || (_cache[7] = ($event: any) => (
                _ctx.getCommentsBySection('getSalaryComments')
              ))
            })
          ], 512), [
            [_vShow, _ctx.expand.comment_salary]
          ])
        ])
      ])
    ])
  ]))
}